import React from 'react';
import { useParams } from 'react-router-dom';

import Preloader from '@web-shared/elements/Preloader';

import { useGeolocation } from './hooks/useGeolocation';
import { BolDetails } from './components/BolDetails';
import { GeolocationErrorPage } from './components/GeolocationErrorPage';
export const ShowBolPage = () => {
  const { token } = useParams<{ token: string }>();
  const { loading, error, refetch, position } = useGeolocation(token);

  if (error) {
    return <GeolocationErrorPage refetch={refetch} />;
  }

  if (loading) {
    return <Preloader />;
  }

  return <BolDetails token={token} position={position!} />;
};
